import { EditShippingAddress as EditShippingAddressShared } from '../../../../components/Containers/ReviewCheckoutDrawer/ShippingAddress/EditShippingAddress';
import { useFlow } from '../../../../providers';
import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';

export const EditShippingAddress = () => {
  const { goPrevStep, goToStep } = useFlow();
  const drawController = usePreAuthDrawCtx();

  return (
    <EditShippingAddressShared
      addresses={drawController.addresses}
      onAddressUpdate={async (addressId) => {
        if (addressId) {
          await drawController.refreshAddresses(addressId);
          goToStep('apply');
        }
      }}
      onCancel={goPrevStep}
      selectedAddress={drawController.selectedAddress}
    />
  );
};
